import {createSelector} from '@ngrx/store';
import {AppState} from '../../interfaces/app-state.interface';

/**
 * Selektoren für das Upload-Feature.
 */
export class UploadSelectors {
  // Private Base-Selectors
  private static selectUpload = (state: AppState) => state.upload;

  // Public Selectors
  public static isDialogOpen = createSelector(
    this.selectUpload,
    state => state.isDialogOpen
  );

  public static isUploading = createSelector(
    this.selectUpload,
    state => state.isUploading
  );

  public static uploadProgress = createSelector(
    this.selectUpload,
    state => state.uploadProgress
  );

  public static error = createSelector(
    this.selectUpload,
    state => state.error
  );

  public static lastUploadedDocument = createSelector(
    this.selectUpload,
    state => state.lastUploadedDocument
  );

  public static lastUploadedFileName = createSelector(
    this.selectUpload,
    state => state.lastUploadedFileName
  );

  public static lastUploadedPath = createSelector(
    this.selectUpload,
    state => state.lastUploadedPath
  );

  public static lastUploadedAblageort = createSelector(
    this.selectUpload,
    state => state.lastUploadedAblageort
  );

  public static pendingNavigation = createSelector(
    this.selectUpload,
    state => state.pendingNavigation
  );

  // Kombinierter Selector für Upload-Status
  public static uploadStatus = createSelector(
    this.isUploading,
    this.uploadProgress,
    this.error,
    (isUploading, progress, error) => ({
      isUploading,
      progress,
      error,
      isSuccess: !isUploading && progress === 100 && !error,
    })
  );
}
